import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, endDate, filters) => ({
        ci_class:   filters.ciClass.join(','),
        operable:   filters.operable,
        state:      filters.state,
        start_date: Math.floor(startDate / TIMESTAMP_MULTIPLY),
        end_date:   Math.floor(endDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'monitoringDaysBySeverity',
        endpoint:           endpoints.monitoring.daysBySeverity,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: item => !item.results ? [] : item.results.map(day => ({
            createdDay:  day.created_date * TIMESTAMP_MULTIPLY,
            severity:    day.severity,
            totalEvents: day.total_events
        }))
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/monitoringDaysBySeverity.js